import React, { useEffect, useState } from "react";

import EventsTab from "./EventsTab/EventsTab";

import { useHeaderContext } from "@/context/header/useHeaderContext";
import { ContentTabs, Screen } from "@/schemas/screen/tabs";

function ContentScreen(): React.JSX.Element {
  const { currentScreen } = useHeaderContext();

  const [currentTab, setCurrentTab] = useState<ContentTabs>(ContentTabs.EVENTS);

  useEffect(() => {
    if (currentScreen.screenId === Screen.CONTENT) {
      setCurrentTab(currentScreen.activeTabId);
    }
  }, [currentScreen]);

  switch (currentTab) {
    case ContentTabs.EVENTS:
      return <EventsTab />;
    default:
      return <></>;
  }
}

export default ContentScreen;
